import { render, staticRenderFns } from "./UnsynchronizedFormatsSelector.vue?vue&type=template&id=63654485&scoped=true&"
import script from "./UnsynchronizedFormatsSelector.vue?vue&type=script&lang=ts&"
export * from "./UnsynchronizedFormatsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./UnsynchronizedFormatsSelector.vue?vue&type=style&index=0&id=63654485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63654485",
  null
  
)

export default component.exports